<template>
  <ElDialog
      v-model="isShow"
      :title="$t('common.step.text.2')"
      :footer="null"
      centered
      :width="400"
      destroyOnClose
      @cancel="close"
      :close-on-click-modal="false"
      :class="[isHeadLine ? 'headline' : 'noheadline']"
  >
    <div class="inners_warning">
      <div>{{ $t('common.emailbox') }}</div>
      <div style="width: 100%;margin-top: 16px;">
        <el-input
            v-model="textarea"
            style="width: 100%"
            :placeholder="$t('common.manual.input')"
            show-word-limit
            rows="16"
            type="textarea"
        />
      </div>
    </div>
    <template #footer>
      <div class="setting_center">
        <el-button size="small" @click="close">{{ $t('common.sss16') }}</el-button>
        <el-button size="small" type="primary" @click="handleDelete" :loading="isloading">{{
            $t('common.add')
          }}
        </el-button>
      </div>
    </template>
  </ElDialog>
</template>

<script setup>
import {ElButton, ElDialog, ElInput, ElMessage} from "element-plus";
import {ref, defineProps, watch, defineEmits} from 'vue'
import {useStore} from "vuex";
import {deleteGroupFile} from "@/api/sidebar";
import {UserTable} from "@/views/Marketing/db_user";
import {v4 as uuidv4} from 'uuid';
import {emailReg} from "@/utils/statusParams";

const store = useStore();
const emit = defineEmits()
const isShow = ref(false);
const fileDirName = ref("")
const loading = ref(false)


const {value, isHeadLine, currentItem} = defineProps({
  value: {type: Boolean, default: false},
  isHeadLine: {type: Boolean, default: false},
  currentItem: {type: Object, default: {}}
})

watch(() => value, (val) => {
  isShow.value = val;
}, {immediate: true})
const close = () => {
  emit("close");
}
const isloading = ref(false)
const textarea = ref("")

// 假设 v-model="textarea"
const textareaToArray = () => {
  if (!textarea.value) return []

  // 按换行符拆分，并过滤掉空行
  const arr = textarea.value
      .split(/\r?\n/)       // 支持 Windows (\r\n) 和 Unix (\n) 换行
      .map(line => line.trim()) // 去掉首尾空格
      .filter(line => line)     // 过滤空行

  return arr
}
const handleDelete = async () => {
  try {
    const res = textareaToArray() || []

    // 分离合法和不合法邮箱
    const validList = []
    const invalidList = []

    res.forEach(item => {
      const email = typeof item === 'string' ? item.trim() : item?.email?.trim?.() || ''
      if (emailReg.test(email)) {
        validList.push({
          email,
          maiContactVOList: item.maiContactVOList || [],
          customerName: item.customerName || "",
          customerCode: item.customerCode || "",
          zoneAddress: item.zoneAddress || "",
          zoneCode: item.zoneCode || "",
          type: 2,
        })
      } else if (email) {
        invalidList.push(email)
      }
    })

    // 如果存在不合规邮箱，提示用户但不中断操作
    if (invalidList.length > 0) {
      ElMessage.warning(`已删除以下不合规邮箱：${invalidList.join('，')}`)
    }

    console.log('最终有效邮箱列表：', validList)
    await emit('addToEmail', validList)
    await close()
  } catch (e) {
    isloading.value = false
    console.error(e)
  }
}


const createDir = () => {
  emit("addDir", fileDirName.value)
}
</script>
<style lang="less" scoped>
.fx-j-c {
  display: flex;
  justify-content: center;
  margin-top: 40px;
}

.title_cdir {
  color: rgba(0, 0, 0, .85);
  font-weight: 700;
  font-size: 14px;
}

.fx-j-r {
  display: flex;
  justify-content: right;
  margin-top: 40px;
}

.inners_warning {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-direction: column;
}
</style>
